import { connect } from 'react-redux';
import React, { Component } from 'react';
import { api, apiUtils } from 'app/services';

var NewsBox = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();}getInitialState()

  {
    return {
      tags: [] };

  }componentDidMount()
  {}render()
  {
    const { tags } = this.state;
    const childrenWithProps = React.Children.map(this.props.children, (child) =>
    React.cloneElement(child, { tags }));

    return <div style={{ height: '100%' }}>{childrenWithProps}</div>;
  }};


function mapStateToProps(state, props) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(NewsBox);
